App.angularApp?.directive 'mfHasOptions', ['$parse', ($parse) ->
    return {
        require: 'ngModel'
        link: (scope, element, attrs, ngModel) =>
            # ngOptions is hard to parse. This regex is the end of the one on
            # https://github.com/angular/angular.js/blob/master/src/ng/directive/ngOptions.js#L236
            expr = attrs.ngOptions.replace(/^.*\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/
                '$1'
            )
            getOptions = $parse(expr)

            ngModel.$validators.mfHasOptions = (modelValue, viewValue) =>
                options = getOptions(scope)
                if not options?.length?
                    return false
                return options.length > 0
    }
]
